<section class="about-banner">
    <div class="container">       
      <div class="row d-flex align-items-center justify-content-center">
        <div class="about-content col-lg-12  mt-5">
          <h1 class="text-white">
            About Me        
          </h1> 
          <p class="text-white link-nav"><a routerLink="/">Home</a><span class="lnr lnr-arrow-right"></span>
            <a routerLink="/about_me"> About</a>
          </p>
          <h4 class="site-banner">
            Get to know me as a programmer. You can find out about my skills and more below.
          </h4>
        </div>  
      </div>
    </div>
  </section>
  
  <section class="job-area offwhite pt-3 section-gap-bottom-90 topic_head">
    <div class="container">
      <div class="row d-flex">
        <div class="col-lg-12">
          <div class="section-title">
            <h1>Who Am I ?</h1>
            <p class="txt-large">
              My name's Nurul Hassan. I'm a web designer and developer based in Jaipur, India.
            </p>
            <p>By day I’m the lead developer at a local agency. By night I spend my time working on freelance projects and some coding problems.</p>
            <p>
              Here, I focus on a range of items and features that we use in life without giving them a second thought. 
            </p>
          </div>
          <div class="section-title autobio">
            <h4 class="text-center pt-4">
             My Autobiography
           </h4>
           <div>
            <br>
            <p class="text-center container">
              Hey, i'm Nurul Hassan.I practice atheism. My weight is 70 Kg and height is 178 cm (5 ft 10 inch). Since childhood i am fascinated by technology, instead of playing with them, i rather loved breaking them down and see the stuff inside them. I also love playing different sports like badminton, carrom, but awfully bad at Basketball and Football. I am introvert by nature and doesn't like to talk so much and interact with strange people.I hate the Indian Education System, and primarily i'm self learner. Most of the time you can see with my headphone and my laptop. My childhood dream occupation includes becoming good chef and a successful Business (I was pretty serious about it). I have Information Technology as my major and currently enrolled in my 4<sup>th</sup> year.<br>
              I got familiar with programming when i was in 1<sup>st</sup> year, i wrote my first program in C. Since than i started acquiring as much as skill set as possible, i have also gained expertise in many of them.
              I have also worked as Freelancer. After which i got more interested in building innovative stuff and have launched 1 startup since then.<br>
              I try to work as hard as possible, and try to pursue the things that interest me. I have seen both failures and success in my life. I like to innovate with technology. I like to surf the web, some of my favorite site are Quora, etc. I don`t like to debating with people on any topic. I am not very avid reader of books,and have read only 2 books in my entire life. Also i like listen to music and keep my headphone on just for it but sometime also used for avoid distraction. I keep myself productive using Freenode, slack and Google Calender. I hate the Engineering Culture and Service Based Companies. My dream is to get work for Product based Company.         
              <br>
              I grew up in Kota with a number of cousing. I was always above average kid. I try to learn from everyone, and tech enthusiast.
              Currently i'm Freelancing. I like to cook food for my family. Also i have interest in gadgets.
              I currently use Dell Vostro 13 1550 (as laptop), Personal Build with 4 GB RAM. Currently i'm  also giving some of my time to Blockchain.
              <br><br>
              To Be Continued......
            </p>
          </div>
        </div>
      </div> 
    </div>
  </div> 
  </section>
  
  <div class="container topic_head">
    <div class="topic_head" >
      <h1 class="text-center">At Glance</h1>
    </div>
  
    <div class="info_box">
      <div class="row">
        <div class="col-md-6 col-sm-12">
          <table class="table table-bordered col-sm-12">
            <tbody>
             <tr>
              <td>Name</td>
              <td>Nurul Hassan</td>
            </tr>
            <tr>
              <td>D.O.B.</td>
              <td>16 April 2000</td>
            </tr>
            <tr>
             <td>Music</td>
             <td>Atif Aslam, Arijit Singh,<br> Coldplay, A.R.Rehman</td>
           </tr>
           <tr>
            <td>Hobbies</td>
            <td>Cooking, <br>Listening Songs </td>
          </tr>
          <tr>
           <td>Good In</td>
           <td>Web Development,Badminton,<br>Singing</td>
         </tr>
         <tr>
           <td>Ask Me</td>
           <td>UX Design, Technology</td>
         </tr>
         <tr>
           <td>Movies</td>
           <td>Annabelle, Marvel Studios Series</td>
         </tr>
       </tbody>
     </table>
   </div>
  
   <div class="col-md-6 col-sm-12">
     <table class="table table-bordered">
       <tbody >
         <tr>
           <td>Profession</td>
           <td>Student (Information Technology)</td>
         </tr>
         <tr>
          <td>College Year</td>
          <td>4<sup>th</sup></td>                
        </tr>
        <tr>
          <td>From</td>
          <td>Kota, Rajasthan</td>
        </tr>
        <tr>
          <td>Keyword</td>
          <td>Foodie, Adventuruos</td>
        </tr>
        <tr>
          <td>Likes</td>
          <td>Cooking, Listning & Singing Music</td>
        </tr>
        <tr>
          <td>TV Shows</td>
          <td>Game Of Thrones, Taarak Mehta Ka Oolta Chashma</td>
        </tr>
        <tr>
          <td>Nationality</td>
          <td>Indian</td>
        </tr>
      </tbody>
    </table>
  </div>
  </div>
  </div>
  </div>
  
